import axios from "axios";
import queryString from "query-string";
import { BASE_URL } from "./apiConfig";
import store from "../app/store";
import { clearAdminProfile, updateAccessToken, updateAdminProfile } from "../features/adminAuthenRedux/adminAuthen";
import adminService from "./adminService";
let isRefreshing = false;

const axiosClient = axios.create({
  baseURL: BASE_URL,
  headers: {
    // "Access-Control-Allow-Origin": "*",
    'ngrok-skip-browser-warning': 'true',
    "Content-Type": "application/json",
  },
  paramsSerializer: (params) => queryString.stringify(params),
});

const onLogout =  () => {
  const dataToken = store.getState().adminAuthen.tokenData;
  if (dataToken && dataToken.token) {
    store.dispatch(clearAdminProfile());    
  }
}

const handleRefreshToken = async () => {
  console.log(`handleRefreshToken tokenData =${JSON.stringify(store.getState().adminAuthen)}`)
  const tokenData = store.getState().adminAuthen.tokenData
  const user = store.getState().adminAuthen.user
  console.log(`handleRefreshToken tokenData =${JSON.stringify(tokenData)}`)
  if(tokenData?.refreshToken === null) return null
    const body = {
      refreshToken: tokenData?.refreshToken,
      user: user
    }
    return await adminService.AuthService.refreshToken(body)
}

axiosClient.interceptors.request.use((config) => {
  const { useAuthorize = false } = config;
    if (useAuthorize) {  
      
      const dataToken = store.getState().adminAuthen.tokenData;    
      console.log(`useAuthorize dataToken =${dataToken}`)
      if (dataToken && dataToken.token) {
        Object.assign(config.headers, {
          Authorization: `Bearer ${dataToken.token}`,
        });
      }
    }
    return config;
  },
  (error) => {
    console.log(`API interceptors err :${JSON.stringify(error)}`);
    return Promise.reject(error);
  },
);

axiosClient.interceptors.response.use(
  (response) => {
    if (response && response.data) {
      return response.data;
    }
    return response;
  },
  async (error) => {
    const originalRequest = error.config;
    const authorize = error?.response.config?.headers["Authorization"]
    const errorCode = error?.response.data?.erroCode
    console.log(`axiosClient response error ${JSON.stringify(error?.response)} isRefreshing =${isRefreshing}`)

    if (error?.response.status === 401
      &&  errorCode === 'TokenExpire' && !isRefreshing) {
        isRefreshing = true;
        const response = await handleRefreshToken()                
        if(response?.token) {          
          console.log(`handleRefreshToken response ${JSON.stringify(response)} `)
          store.dispatch(updateAccessToken(response));    
          axiosClient.defaults.headers.common["Authorization"] = `Bearer ${response?.token}`;
          isRefreshing = false;
          return axiosClient(originalRequest);
        }else{
          isRefreshing = false;
        }
    }else if (error?.response.status === 401) {
      isRefreshing = false;       
      onLogout()      
    }else{
      isRefreshing = false;      
    }   
    return Promise.reject(error); 
  }
);

export default axiosClient;
